import { EligibilitySubmission } from '../../global'
import amplitude from './amplitude'
import { EnrollmentExperiment } from './client'
import { FeatureFlag } from './experiment'

const experiment: EnrollmentExperiment = {
    active(featureFlag: FeatureFlag): boolean {
        const variant = amplitude.variant(featureFlag)
        return variant.value === 'on'
    },

    async start(submission: EligibilitySubmission): Promise<void> {
        await amplitude.fetch({
            user_id: submission.id,
            user_properties: {
                campaign_id: submission.campaignId,
                partner_type: submission.partner.type,
                partner_name: submission.partner.name,
            },
        })
    },
}

export default experiment
